import styled, { css } from 'styled-components';
import { InformationRowSizeThemes } from './sizes';
const InformationRowVertical = ({ size, theme, }) => {
    const sizeTheme = InformationRowSizeThemes[size];
    return css `
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing[sizeTheme.gapVertical]}px;
    ul,
    ul li {
      padding-inline-start: 0;
    }
    ul li:first-child {
      margin-block-start: 0;
    }
  `;
};
const InformationRowHorizontal = ({ size, theme, }) => {
    const sizeTheme = InformationRowSizeThemes[size];
    return css `
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: ${theme.spacing[sizeTheme.gapHorizontal]}px;
  `;
};
const InformationRowValueOnly = ({ size, theme, }) => {
    const sizeTheme = InformationRowSizeThemes[size];
    return css `
    display: flex;
    flex-direction: row;
    gap: ${theme.spacing[sizeTheme.gapVertical]}px;
  `;
};
export const InformationRowContainer = styled.div `
  margin-block: ${({ theme }) => theme.spacing.xs}px;
  ${({ $type, $size, theme }) => $type === 'vertical'
    ? InformationRowVertical({ size: $size, theme })
    : $type === 'valueOnly'
        ? InformationRowValueOnly({ size: $size, theme })
        : InformationRowHorizontal({ size: $size, theme })}
`;
